import {Box, useTheme} from "@mui/material"
import React from "react"
import Content from "../../components/Content"
import {evaluateFullHeight} from "../../misc/utils"

export const containerBoxPrototype = [
    {
        "key": "variant",
        "type": "SELECT",
        "label": "Variante",
        "size": 3,
        "options": [
            {"value": "DEFAULT", "label": "Default"},
            {"value": "GREY", "label": "Grey"},
            {"value": "SHADOW", "label": "Shadow"},
        ],
    },
    {
        key: "padding",
        type: "STRING",
        label: "Padding",
        size: 3,
    },
]

const WIDE_QUERY_KEY = "@container (min-width: 400px)"

const ContainerBox = ({container, triggerAction}) => {
    const {children, spacing = 0, variant, action, fullHeight, maxWidth, minWidth} = container
    const theme = useTheme()
    const variantStyles = variant ? theme.Box?.[variant] : undefined
    const onClick = () => action && triggerAction(action)
    return (
        <Box
            sx={{
                ...theme.Box.OuterWrapper,
                minWidth,
                maxWidth,
                height: evaluateFullHeight(fullHeight),
                display: "flex",
            }}>
            <Box
                onClick={onClick}
                display="flex"
                sx={{
                    ...theme.Box.Wrapper,
                    ...variantStyles,
                    [WIDE_QUERY_KEY]: {
                        ...theme.Box.Wrapper?.[WIDE_QUERY_KEY],
                        ...variantStyles?.[WIDE_QUERY_KEY],
                    },
                    cursor: action ? "pointer" : "default",
                    width: "100%",
                    padding: container?.padding ?? "8px"
                }}
                gap={`${spacing}px`}>
                {children.map((child) => (
                    <Content
                        child={child}
                        key={child.id}
                    />
                ))}
            </Box>
        </Box>
    )
}

export default ContainerBox
